export default defineNuxtPlugin((nuxtApp) => {
  const methods = {
    formatDate(dateString, options = {}) {
      if (!dateString) return "";

      const date = new Date(dateString);

      // Get the current locale from i18n
      const { $i18n } = nuxtApp;
      let currentLocale = "en-GB"; // fallback locale

      if ($i18n && $i18n.locale) {
        currentLocale = $i18n.locale.value || $i18n.locale;

        // Map specific locale codes to valid Intl.DateTimeFormat locales
        const localeMap = {
          nl: "nl-NL",
          en: "en-GB",
          fr: "fr-FR",
          de: "de-DE",
          befr: "fr-BE",
          benl: "nl-BE",
        };

        currentLocale = localeMap[currentLocale] || currentLocale;
      }

      if (import.meta.server) {
        // Use the mapped locale for server-side rendering
        return new Intl.DateTimeFormat(currentLocale, {
          day: "numeric",
          month: "long",
          year: "numeric",
          ...options,
        }).format(date);
      }

      // On client side, also use the i18n locale instead of navigator.language
      return new Intl.DateTimeFormat(currentLocale, {
        day: "numeric",
        month: "long",
        year: "numeric",
        ...options,
      }).format(date);
    },
  };

  nuxtApp.provide("date", methods);
});
